var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-button-wrapper"},[_c('v-btn',{staticClass:"create-button",on:{"click":_vm.goToNewPage}},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }